import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
import { TranslationProvider } from "./context/translation-context"
import { FavoritesProvider } from "./context/favorites-context"
import { CookieConsentProvider } from "./context/cookie-consent-context"
import { ThemeProvider } from "./components/theme-provider"
import { MainLayout } from "./components/layout/main-layout"
import { HomePage } from "./components/pages/home-page"
import { CategoryPage } from "./components/pages/category-page"
import { GamePage } from "./components/pages/game-page"
import { StatisticsPage } from "./components/games/common/statistics-page"
import { CookieConsentBanner } from "./components/cookie-consent-banner"
import { GoogleAnalytics } from "./components/google-analytics"
import { Toaster } from "./components/ui/sonner"
import { ADS_CONFIG } from "./config/ads"

function App() {
  return (
    <Router>
      <TranslationProvider>
        <FavoritesProvider>
          <CookieConsentProvider>
            <ThemeProvider defaultTheme="dark">
              <Routes>
                <Route path="/" element={<MainLayout />}>
                  <Route index element={<HomePage />} />
                  <Route path="category/:categoryId" element={<CategoryPage />} />
                  <Route path="game/:gameId" element={<GamePage />} />
                  <Route path="statistics" element={<StatisticsPage />} />
                </Route>
                <Route path="/:lang" element={<MainLayout />}>
                  <Route index element={<HomePage />} />
                  <Route path="category/:categoryId" element={<CategoryPage />} />
                  <Route path="game/:gameId" element={<GamePage />} />
                  <Route path="statistics" element={<StatisticsPage />} />
                </Route>
              </Routes>
              <CookieConsentBanner />
              <GoogleAnalytics measurementId={ADS_CONFIG.GA_MEASUREMENT_ID} />
              <Toaster />
            </ThemeProvider>
          </CookieConsentProvider>
        </FavoritesProvider>
      </TranslationProvider>
    </Router>
  )
}

export default App 